import { render, staticRenderFns } from "./insured.vue?vue&type=template&id=7d5470ce&"
import script from "./insured.vue?vue&type=script&lang=js&"
export * from "./insured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports